<template>
    <form class="d-inline-block" method="post" @submit.prevent="submit">
        <fieldset :disabled="locked">
            <div class="card">
                <div class="card-header">
                    <h4 class="card-title">Send Revenue to Prosperity</h4>
                </div>
                <div class="card-body">
                    <div class="form-group">
                        <label for="information">
                            {{ description }}
                        </label>
                        <input type="text" id="information" class="form-control" :placeholder="state" disabled>
                    </div>
                    <div>
                        <small class="form-text text-success" v-if="available > 0">
                            {{ 'admin.prosperity.available' | lang({ total: available }) }}
                        </small>
                        <small class="form-text text-muted" v-else>
                            {{ 'admin.prosperity.none' | lang }}
                        </small>
                        <small class="form-text text-info" v-if="availableWeekly > 0">
                            {{ 'admin.prosperity.availableWeekly' | lang({ total: availableWeekly, countdown: weeklyCountdown }) }}
                        </small>
                        <small class="form-text text-muted" v-else>
                            {{ 'admin.prosperity.noneFast' | lang }}
                        </small>
                        <small class="form-text text-muted" v-if="missingPaymentSettings > 0">
                          {{ 'admin.prosperity.missingPaymentSettings' | lang({ total: missingPaymentSettings }) }}
                        </small>
                        <small class="form-text text-muted" v-if="belowMinimumThreshold > 0">
                          {{ 'admin.prosperity.belowMinimumThreshold' | lang({ total: belowMinimumThreshold }) }}
                        </small>
                    </div>
                </div>
                <div class="card-footer">
                    <button type="submit" class="btn btn-primary">
                        {{ 'admin.prosperity.send' | lang }}
                    </button>
                </div>
            </div>
        </fieldset>
    </form>
</template>

<script>
  import TToast from "#/js/components/TToast";
  import axios from 'axios';
  import {DateTime} from 'luxon';

  export default {
    name: "ProsperitySendRevenue",
    props: {
      'route': String
    },
    data() {
      return {
        toast: new TToast(),
        routes: {
          submit: '',
        },
        processing: true,
        available: 0,
        availableWeekly: 0,
        missingPaymentSettings: 0,
        belowMinimumThreshold: 0,
        weeklySchedule: null,
        loading: true,
      }
    },
    mounted() {
      Echo.private('prosperity')
        .listen('Prosperity\\SendRevenueError', (e) => {
          this.toast.error(e.message);
          this.getStatus();
        })
        .listen('Prosperity\\SendRevenueSuccess', (e) => {
          this.toast.success(e.message);
          this.getStatus();
        });
      this.getStatus();
    },
    beforeDestroy() {
      Echo.leave('prosperity');
    },
    methods: {
      getStatus() {
        this.loading = true;
        axios.get(this.route).then((response) => {
          const data = response.data;
          if (!data) return;
          this.processing = data.processing;
          this.routes = data.routes;
          this.available = data.available;
          this.availableWeekly = data.availableWeekly;
          this.missingPaymentSettings = data.missingPaymentSettings;
          this.belowMinimumThreshold = data.belowMinimumThreshold;
          this.weeklySchedule = data.weeklySchedule;
        }).catch((response) => {
          this.error(response);
        }).finally(() => {
          this.loading = false;
        })
      },
      submit() {
        this.loading = true;
        axios.post(this.routes.submit).then((response) => {
          this.toast.success(response.data.message);
        }).catch((error) => {
          console.error(error);
          this.error(error);
        }).finally(() => {
          this.getStatus();
        });
      },
      error(error) {
        const response = error.response;
        const data = response.data;
        this.toast.error(data.message || error.message || 'An error occurred.');
        this.loading = false;
      }
    },
    computed: {
      weeklyCountdown() {
        if (!this.weeklySchedule) return '-';
        let dateTime = DateTime.fromISO(this.weeklySchedule);
        const difference = dateTime.diff(DateTime.now()).toFormat("d 'days and' h 'hours'")
        return `${difference}`; // Add (${dateTime.toLocaleString(DateTime.DATETIME_MED)}) for proper date.
      },
      locked() {
        return this.processing || this.loading;
      },
      description() {
        return Lang.get('admin.prosperity.description', {'prosperity': 'Prosperity'})
      },
      state() {
        return this.processing ? Lang.get('admin.prosperity.processing') : Lang.get('admin.prosperity.ready');
      }
    }
  }
</script>

<style scoped>

</style>